import { FC, ReactNode } from "react"

interface Props {
  title: ReactNode
  subtitle?: ReactNode
}

export const PageTitle: FC<Props> = ({ title, subtitle }) => (
  <header className="mb-8 md:mb-12 text-center">
    <h1 className="text-2xl md:text-4xl font-bold text-gray-800 dark:text-gray-200">{title}</h1>
    {subtitle && <div className="mt-5 text-xl text-gray-500 dark:text-gray-400">{subtitle}</div>}
  </header>
)
